import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_RESTAURANTS_ADMIN = 'SET_RESTAURANTS_ADMIN';
export const LOADING_RESTAURANT = 'LOADING_RESTAURANT';
export const ERROR_RESTAURANT = 'ERROR_RESTAURANT';

const setRestaurantsAdmin = payload => ({ type: SET_RESTAURANTS_ADMIN, payload });

export const setRestaurants = payload => {
    return dispatch => {
        return db.ref(`${Constants.RESTAURANTS}`).once("value")
        .then((snapshot) => {
            if(snapshot.exists() && snapshot.val() !== null) {
                var restaurants = snapshot.val();
                dispatch(setRestaurantsAdmin(restaurants));
            } else {
                console.log("getRestaurant not found: " + null);
                dispatch(setRestaurantsAdmin(null));
            }
        })
        .catch((err) => {
            console.log("getRestaurant not found: " + err);
            dispatch(setRestaurantsAdmin(null));
        });
    };
};